module.exports = __webpack_public_path__ + "img/P150T_weapon_140.071f4fd5.png";